import { useEffect } from 'react';

import { Modal } from '../../../../../../components';
import { EditMetadataForm } from './components/EditMetadataForm';
import { EditMetadataFooter } from './components/EditMetadataFooter';
import { useEditMetadataForm } from './hooks/useEditMetadataForm';
import { stringifyMetadataForApi } from './utils';
import type { ActionCardPayload } from '../KnowledgeCard';

type EditMetadataModalProps = {
  open: boolean;
  onClose: () => void;
  saving: boolean;
  actionPayload: ActionCardPayload | null;
  onSave: (params: { id: string; name: string; metadata: string }) => void;
};

const EditMetadataModalContent: React.FC<EditMetadataModalProps> = ({
  open,
  onClose,
  saving,
  actionPayload,
  onSave,
}) => {
  const form = useEditMetadataForm(actionPayload?.metadata_fields ?? null);
  const { reset: resetForm } = form;
  const metadataSource = actionPayload?.metadata_fields ?? null;

  useEffect(() => {
    if (open) {
      resetForm(metadataSource);
    }
  }, [open, resetForm, metadataSource]);

  const handleSave = () => {
    onSave({
      id: actionPayload?.id || '',
      name: actionPayload?.name || '',
      metadata: stringifyMetadataForApi(form.state),
    });
  };

  return (
    <Modal
      title="Edit Metadata"
      open={open}
      onClose={onClose}
      size="medium"
      contentClassName="p-0"
      footer={
        <EditMetadataFooter
          valid={form.valid}
          saving={saving}
          onCancel={onClose}
          onSave={handleSave}
        />
      }
    >
      <EditMetadataForm form={form} />
    </Modal>
  );
};

export const EditMetadataModal: React.FC<EditMetadataModalProps> = props => (
  <EditMetadataModalContent
    key={props.actionPayload?.id || 'edit-metadata'}
    {...props}
  />
);

export type { MetadataEditFormState } from './types';
